//import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FMPSelect from "../pureForm/FMPSelect";

class FMPPaymentOptionSelect extends PureComponent {
	render () {
		const {
			label, value, path, onChange,
			error, helpText, md,
		} = this.props;

		const options = [
			{ value : 'cash', display : 'Cash'},
			{ value : 'credit', display : 'Credit'},
			{ value : 'debit', display : 'Debit'},
		];

		return (
			<FMPSelect
				label={label}
				path={path}
				value={value}
				error={error}
				options={options}
				onChange={onChange}
				md={md}
				helpText={helpText}
				multiple={true}
			/>
		);
	}
}

FMPPaymentOptionSelect.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.array.isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	classes : PropTypes.object,
	md : PropTypes.number,
	helpText : PropTypes.string,
	productTypes : PropTypes.array,

	dataDumpMap : PropTypes.object,
};

FMPPaymentOptionSelect.defaultProps =  {
	md : 12,
	label : 'Payment option select',
};

export default FMPPaymentOptionSelect;